var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"idle-view",class:{isIdle: _vm.isIdle}},[_c('div',{staticClass:"overlay"}),_c('sprite',{ref:"sprite",attrs:{"spriteId":"touch","spriteSrc":require('../assets/touch.png'),"spriteW":180,"spriteH":215}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }